import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import { App } from './App';

const rootElmt = document.getElementById('root') as HTMLElement;
rootElmt.style.height = '100%';

if (rootElmt && rootElmt.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElmt, <App />);
} else {
  const root = ReactDOM.createRoot(rootElmt);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
if (rootElmt) {
  Modal.setAppElement(rootElmt);
}
